// poi.service.ts
import { inject, Injectable } from '@angular/core';
import { DataLayerTypeStore } from '../../stores/data-layer-type/data-layer-type.state';
import { DataLayerStore } from '../../stores/data-layer/data-layer.state';
import { DataLayerType } from '../../models/data-layer-type';
import { PoiConf } from '../grid-widget-config.service';

@Injectable({ providedIn: 'root' })
export class PoiHelperService {
  private readonly layerTypeStore = inject(DataLayerTypeStore);
  private readonly layerStore = inject(DataLayerStore);

  /**
   * Get available POI types filtered by year and excluded types
   */
  getAvailablePoiTypes(
    year?: number | string,
    excludeTypes?: string[]
  ): DataLayerType[] {
    let types = this.layerTypeStore.getByType('Point');

    if (year) {
      types = types.filter(type =>
        this.layerStore.parentHasYear(type._id, Number(year))
      );
    }

    if (excludeTypes?.length) {
      types = types.filter(type => !excludeTypes.includes(type._id));
    }

    return types;
  }

  /**
   * Check if POI has layers for given year
   */
  poiAvailableInYear(year: number | string, poiId: string): boolean {
    return this.layerStore.parentHasYear(poiId, Number(year));
  }

  /**
   * Get POI geo data by year
   */
  getPoiGeoDataByYear(year: number | string, poiId: string): string {
    return (
      this.layerStore.filterByParentAndYear(poiId, Number(year))?.geoData || ''
    );
  }

  /**
   * Get POI layer by year
   */
  getPoiLayerByYear(year: number | string, poiId: string): string {
    return (
      this.layerStore.filterByParentAndYear(poiId, Number(year))?._id || ''
    );
  }

  /**
   * Build POI config from selected types
   */
  buildPoiConfig(selectedTypes: DataLayerType[]): PoiConf[] {
    const config: PoiConf[] = [];
    selectedTypes.forEach(type => {
      config.push({ type: type._id });
    });
    return config;
  }
}
